import _ from 'lodash';

export function deepCopy<T>(obj: T): T {
    // Lodash `cloneDeep` is faster than `structureClone`
    return _.cloneDeep(obj);
}

export function shallowCopy<T>(obj: T): T {
    return { ...obj };
}
